import axios from "../../config/axiosConfig";
import { CREATE_PRODUCTION_REPACKING, GET_PRODUCTION_REPACKINGS, PRODUCTION_REPACKING_REQUEST, UPDATE_PRODUCTION_REPACKING, DELETE_PRODUCTION_REPACKING, PRODUCTION_REPACKING_FAILURE } from "../types";

export const getProductionRePackings = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production-repacking/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_REPACKINGS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createProductionRePacking = (production) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      return axios.post("/production-repacking/add", production,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PRODUCTION_REPACKING, payload: response.data });
        } else {
          dispatch({
            type: PRODUCTION_REPACKING_FAILURE,
            error: "Production create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateProductionRePacking = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      const { auth } = getState();
      return axios.put("/production-repacking/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }
      }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PRODUCTION_REPACKING,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PRODUCTION_REPACKING_FAILURE,
            error: "Production code update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteProductionRePacking = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      return axios.delete(`/production-repacking/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PRODUCTION_REPACKING, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};